import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { BaryModalForm } from '../../../../../../models/bary-modal-form';
import { BaryModalEvent } from '../../../../../../models/bary-modal-event';
import { InsuranceItemCategory, InsuranceItemCategoryControls } from '../../../../../../models/insurance-item-view.model';
import { OfferService } from '../../../../../../services/offer.service';
import { OfferViewDTO } from '../../../../../../models/offer-view-dto.type';
import { Transporter } from '../../../../../../models/transporter.model';
import { BaryFormFactoryService } from '../../../../../../services/bary-form-factory.service';
import { CurrentDataService } from '../../../../../../services/current-data-service';
import { NgIf } from '@angular/common';
import { TranslateDirective } from '../../../../../../directives/translate.directive';
import { BaryTitleComponent } from '../../../bary-title/bary-title.component';
import { BaryInputTextComponent } from '../../../bary-input-text/bary-input-text.component';
import { BaryInputSwitchComponent } from '../../../bary-input-switch/bary-input-switch.component';
import { BaryInputMultiSelectComponent } from '../../../bary-input-multi-select/bary-input-multi-select.component';
import { BaryButtonComponent } from '../../../bary-button/bary-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { InsuranceItemCategoryService } from '../../../../../../services/insurance-item-category.service';
import { forkJoin } from 'rxjs';
import { mapAsBody } from '../../../../util/request-util';

@Component({
  selector: 'jhi-modal-add-insurance-item-category',
  templateUrl: './modal-add-insurance-item-category.component.html',
  standalone: true,
  imports: [NgIf, TranslateDirective, BaryTitleComponent, BaryInputTextComponent, BaryInputSwitchComponent, BaryInputMultiSelectComponent, BaryButtonComponent, TranslateModule],
})
export class ModalAddInsuranceItemCategoryComponent extends BaryModalForm implements OnInit {
  readonly #fb = inject(FormBuilder);
  readonly #modalRef = inject(MDBModalRef);
  readonly #bff = inject(BaryFormFactoryService);
  readonly #offerService = inject(OfferService);
  readonly #currentDataService = inject(CurrentDataService);
  readonly #insuranceItemCategoryService = inject(InsuranceItemCategoryService);

  override model: InsuranceItemCategory = new InsuranceItemCategory();

  public controls?: InsuranceItemCategoryControls;
  public options: Array<{ label: string; value: any }> = [];
  public transporter!: Transporter;

  constructor() {
    super();
  }

  public ngOnInit(): void {
    this.#currentDataService.getCurrentTransporter().subscribe((transporter: Transporter): void => {
      this.transporter = transporter;

      forkJoin({
        itemCategories: this.#insuranceItemCategoryService.query().pipe(mapAsBody),
        offers: this.#offerService.getTransporterOffersWithName(this.transporter.id!),
      }).subscribe(data => {
        const itemsNature = data.itemCategories.map(it => it.oldItemsNature!);
        this.controls = this.#bff.makeInsuranceItemCategoryControls(this.model, itemsNature);
        this.modalForm = this.#fb.group(this.controls);
        this.options = data.offers.map((offer: OfferViewDTO) => ({ label: offer.name!, value: offer }));
      });
    });
  }

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.#modalRef.hide();
  }

  public changeActif($event: any): void {
    this.model.quotationRequired = !!$event;
  }

  override handleSubmit(): void {
    if (this.modalForm.invalid) {
      this.modalForm.markAllAsTouched();
      this.focusOnFirstError();
    } else {
      this.model.newItemsNature = this.controls?.newItemsNature.value?.trim();
      this.model.offers = this.controls?.offers.value;
      this.action.next(new BaryModalEvent({ submit: true, value: this.model.serialize() }));
      this.#modalRef.hide();
    }
  }
}
